import {
    SET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS,
    RESET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS
} from './constants';

export function setTimesheetTimesheetEntriesAPIErrors(errors: Array<{}>) {
    return {
        type: SET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS,
        payload: {
            errors
        }
    };
}

export function resetTimesheetTimesheetEntriesAPIErrors() {
    return {
        type: RESET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS,
        payload: {}
    };
}
